export class Pagination {
  public pageCount: number;
  public initialPage: number;
  public totalCount: number;

  constructor(headers: any, limit: number, offset: number) {
    this.totalCount = parseInt(headers['x-total-count'], 10);
    this.pageCount = this.getPageCount(limit);
    this.initialPage = this.getInitialPage(offset);
  }

  private getPageCount(limit: any) {
    const itemsPerPage = limit;
    const pages = Math.floor((this.totalCount - 1) / itemsPerPage) + 1;
    return pages;
  }

  private getInitialPage(offset: any) {
    return (parseInt(offset, 10) || 1) - 1;
  }
}
